module.exports = __webpack_public_path__ + "img/c12.546beda1.png";